import { render } from "./NavigationMenu.vue?vue&type=template&id=7050d6c3&scoped=true"
import script from "./NavigationMenu.vue?vue&type=script&lang=js"
export * from "./NavigationMenu.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-7050d6c3"

export default script